import { NetworkError } from '../../api/client';
import { SessionLostError } from '../../api/session';
import { useEffect } from 'react';
import { ApiError } from '../../api/client';
import { report } from '../../app/report';
import { MessageScreen } from '../auth/screens';
import s from './common.module.css';

interface Props {
  error: unknown;
  onRetry: () => void;
  fullScreen?: boolean;
}

/** Failed load: a lost session needs a reopen (spec §5.4); anything else can be retried in place. */
export function LoadFailed({ error, onRetry, fullScreen }: Props) {
  useEffect(() => {
    // The request that failed goes with the code: «BAD_REQUEST GET /v1/passes» tells where to look.
    const endpoint = error instanceof ApiError || error instanceof NetworkError ? ` ${error.endpoint ?? ''}` : '';
    report('load_failed', `${error instanceof ApiError ? error.code : error instanceof Error ? `${error.name}: ${error.message}` : ''}${endpoint}`.trim());
  }, [error]);
  if (error instanceof SessionLostError) {
    return <MessageScreen title="Откройте приложение заново" text="Сессия закончилась. Закройте приложение и откройте его снова из бота." />;
  }
  const text = error instanceof NetworkError ? 'Нет связи. Проверьте интернет.' : 'Не удалось загрузить.';
  if (fullScreen) return <MessageScreen title="Не удалось загрузить" text={text} onRetry={onRetry} />;
  return (
    <p className={s.inlineError} role="alert">
      {text}{' '}
      <button type="button" className={s.retry} onClick={onRetry}>
        Повторить
      </button>
    </p>
  );
}
